/**
 * XNGAGE CONFIDENTIAL
 * __________________________
 *
 * Copyright (C) 2021 Xngage - All Rights Reserved
 *
 * All code or information contained herein is, and remains the
 * property of Xngage LLC and its customers.  The intellectual
 * and technical concepts contained are proprietary to Xngage LLC
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Xngage LLC.
 */
import { xBaseTheme } from "@monsma/XDL/types";
import { css } from "styled-components";

export default {
    fontFamilyImportUrl: "",
    body: {
        size: "15px",
        weight: 400,
        fontFamily: "'Inter', 'Open Sans', 'Roboto', 'Lato', sans-serif",
    },
    p: {
        size: "15px",
        weight: 400,
        css: css`
            margin-bottom: 1rem;
        `,
    },
    h1: {
        size: "30px",
        weight: 800,
        color: "secondary.main",
        css: css`
            margin-bottom: 1rem;
        `,
    },
    h2: {
        size: "28px",
        weight: 700,
        color: "secondary.main",
        css: css`
            margin-bottom: 1rem;
        `,
    },
    h3: {
        size: "22px",
        weight: 700,
        color: "secondary.main",
        css: css`
            margin-bottom: 1rem;
        `,
    },
    h4: {
        size: "20px",
        weight: 700,
        color: "common.ui10",
        css: css`
            margin-bottom: 1rem;
        `,
    },
    h5: {
        size: "16px",
        weight: 700,
        color: "common.ui10",
        css: css`
            margin-bottom: 1rem;
        `,
    },
    h6: {
        size: "14px",
        weight: 700,
        color: "common.ui10",
        css: css`
            margin-bottom: 1rem;
        `,
    },
    headerPrimary: {
        forwardAs: "p",
        size: "24px",
        fontFamily: "'Inter', 'Open Sans', 'Roboto', 'Lato', sans-serif",
        color: "text.main",
        transform: "uppercase",
    },
    headerSecondary: {
        forwardAs: "p",
        size: "15px",
        fontFamily: "'Inter', 'Open Sans', 'Roboto', 'Lato', sans-serif",
        transform: "uppercase",
        weight: 800,
    },
    headerTertiary: {
        forwardAs: "p",
        size: "15px",
        fontFamily: "'Inter', 'Open Sans', 'Roboto', 'Lato', sans-serif",
        color: "text.main",
        transform: "uppercase",
    },
    legend: {
        forwardAs: "span",
        size: "10px",
        color: "text.accent",
        transform: "uppercase",
        weight: 600,
    },
} as xBaseTheme["typography"];
